import api from "../utils/api";
import {
  APPLY_PROMO_REQUEST,
  APPLY_PROMO_SUCCESS,
  APPLY_PROMO_FAIL,
  CLEAR_PROMO,
} from "./constants/promo";

export const applyPromo = (code: string, cartItems: any[]) => async (
  dispatch: any,
  getState: any
) => {
  try {
    dispatch({ type: APPLY_PROMO_REQUEST });

  

    const { data } = await api.post("/promos/apply", {
      code,
      cartItems
    });
  console.log(data)

    dispatch({
      type: APPLY_PROMO_SUCCESS,
      payload: {
        code: data.code,
        discount: data.discount,
        type: data.type,
        total: data.Total,
        subTotal: data.subTotal,
        discountValue: data.discountValue,
        validItems: data.validItems
      },
    });
  } catch (err: any) {
    dispatch({
      type: APPLY_PROMO_FAIL,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const clearPromo = () => (dispatch: any) => {
  dispatch({ type: CLEAR_PROMO });
};